exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preloader-container {\r\n\tposition: fixed;\r\n\theight: 100%;\r\n\tz-index: 9999;\r\n\ttop: 0;\r\n\twidth: 100%;\r\n\tleft: 0;\r\n\t/* transform: translate(-50%, -50%); */\r\n\tbackground: rgba(0,0,0,0.7);\r\n\tdisplay:none;\r\n}\r\n.preloader-container.active { display:block; }\r\n.preloader-wrapper {\r\n\tposition:absolute;\r\n\ttop:50%;\r\n\tleft:50%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-master/custom-loader/custom-loader.component.css
// module id = ../../../../../src/app/mnt-master/custom-loader/custom-loader.component.css
// module chunks = main